import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "primereact/resources/primereact.min.css";
import "primeflex/primeflex.min.css";
import "react-toastify/dist/ReactToastify.css";
import "@idwal/idwal-react-components/css/idwal-theme.css";
import "primeicons/primeicons.css";
import App from "./App";
import common_en from "@idwal/idwal-react-components/translations/en/common.json";
import app_locale_en from "./translations/en/locale.json";
import {AwsConfigAuth} from "./cognito/authConfig";
import {Amplify} from "aws-amplify";
import i18next from "i18next";
import {I18nextProvider} from "react-i18next";
import { Authenticator } from "@aws-amplify/ui-react";
import { BrowserRouter } from "react-router-dom";
import { LDProvider } from "launchdarkly-react-client-sdk";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { CookiesProvider } from "react-cookie";

Amplify.configure(AwsConfigAuth);

i18next
    .init({
        interpolation: { escapeValue: false },
        lng: "en",
        resources: {
            en: {
                common: common_en,
                locale: app_locale_en
            }
        }
    }
);

const clientSideID = process.env.REACT_APP_LD_CLIENT_SIDE_ID ?? ''

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <LDProvider clientSideID={clientSideID}>
                <I18nextProvider i18n={i18next}>
                    <CookiesProvider>
                        <Authenticator.Provider>
                            <BrowserRouter>
                                <App />
                            </BrowserRouter>
                        </Authenticator.Provider>
                    </CookiesProvider>
                </I18nextProvider>
            </LDProvider>
        </Provider>
    </React.StrictMode>
);
